import clsx from 'clsx';
import { formatCurrencyConstrained, formatCurrency } from '@atc/string-fns';
import React, { memo } from 'react';
import { Text } from 'reaxl';
import { InfoIcon } from 'reaxl-molecules';
import { jsxs, jsx } from 'react/jsx-runtime';
function BreakdownLineItem(_ref) {
  let {
    label,
    priceIndicator,
    size = 300,
    weight = 'normal',
    value,
    valueSuffix,
    hasDecimals = false,
    isInfoIcon = false,
    infoIconText,
    infoIconId,
    className
  } = _ref;
  if (typeof value === 'number' && value <= 0) return null;
  return /*#__PURE__*/jsxs("li", {
    className: clsx('display-flex justify-content-between align-items-center text-subdued', className),
    children: [/*#__PURE__*/jsxs(Text, {
      weight: weight,
      size: size,
      children: [label, isInfoIcon && !!infoIconText && /*#__PURE__*/jsx(InfoIcon, {
        id: infoIconId,
        infoText: infoIconText,
        placement: "top",
        className: "margin-left-1"
      })]
    }), /*#__PURE__*/jsx(Text, {
      weight: weight,
      size: size,
      className: "flex-shrink-0",
      children: /*#__PURE__*/ /*#__PURE__*/React.isValidElement(value) ? value : /*#__PURE__*/jsxs("span", {
        className: "white-space-nowrap",
        children: [priceIndicator, ' ', (value || value === 0) && (hasDecimals ? formatCurrencyConstrained(value) : formatCurrency(Math.floor(value))), valueSuffix]
      })
    })]
  });
}
var BreakdownLineItem$1 = /*#__PURE__*/memo(BreakdownLineItem);
export { BreakdownLineItem$1 as default };
